import axiosInstance from "../axiosInstance";

/** Demand plan forecast runs (control-tower api/plan-forecast-run). */
export const planForecastRunService = {
  /** Latest run of each plan row — roll-up totals only, with progress and the stale flag. */
  latest: async (planId) => {
    const response = await axiosInstance.get(
      `/plan-forecast-run?plan_id=${encodeURIComponent(planId)}`,
    );
    return Array.isArray(response.data) ? response.data : [];
  },

  /** Start a run for a plan row (or a parent category). Returns the run straight away. */
  start: async (planId, rowKey, params) => {
    const response = await axiosInstance.post("/plan-forecast-run", {
      plan_id: planId,
      row_key: rowKey,
      params,
    });
    return response.data;
  },

  /** One run with its SKU → Product → Category roll-up. */
  get: async (runId) => {
    const response = await axiosInstance.get(`/plan-forecast-run/${runId}`);
    return response.data;
  },

  /** Email a finished run's Excel to the signed-in user. → { _id, email: { status, to, at } } */
  email: async (runId) => {
    const response = await axiosInstance.patch(`/plan-forecast-run/${runId}`, {
      action: "email",
    });
    return response.data;
  },

  /** Stop a running run: no more SKUs start; it ends as "cancelled". */
  cancel: async (runId) => {
    const response = await axiosInstance.patch(`/plan-forecast-run/${runId}`, {
      action: "cancel",
    });
    return response.data;
  },
};
